import HighRewardAdIcon from '../../../assets/icons/punch/high-reward-ad-icon.svg';
import HighRewardCloseXIcon from '../../../assets/icons/punch/high-reward-close-x.svg';
import HighRewardCrownIcon80 from '../../../assets/icons/punch/con.png';
import PartyPopperIcon from '../../../assets/icons/punch/pm-cta-cat-party.png';
import NPAY_ICON_IMAGE from '../../../assets/images/time-nyang/npay-icon.svg';

const POPUP_CARD_HEIGHT_BY_KIND = {
  success: 300,
  'ad-rest': 295,
  npay: 400,
  'npay-complete': 387,
  'near-point': 320,
  'near-free': 300,
  'near-exhausted': 235,
};

const AD_PRIMARY_LABEL_BY_KIND = {
  success: '광고 보고 400P 받기',
  'ad-rest': '1P 획득하기',
  npay: '광고 보고 수령',
  'near-point': '10P 받기',
};

export default function TimeNyangRewardPopup({ popup, onClose, onConfirm, onSkip, isPrimaryAdLoading = false }) {
  if (!popup) return null;

  const cardHeight =
    popup.kind === 'near-point' && popup.turn === 3 ? 355 : (POPUP_CARD_HEIGHT_BY_KIND[popup.kind] ?? 316);
  const titleClass = "m-0 text-center font-['Pretendard'] text-[22px] font-extrabold leading-[1.4] text-gray05";
  const descClass =
    "m-0 whitespace-pre-line text-center font-['Pretendard'] text-sm font-bold leading-[1.4] text-gray04";
  const primaryBtnClass =
    "flex h-[54px] w-[300px] cursor-pointer items-center justify-center gap-[10px] rounded-[8px] border-0 bg-[#1E1E1E] py-4 text-center font-['Pretendard'] text-[16px] font-bold leading-[1.4] text-white";
  const secondaryBtnClass =
    "w-[300px] cursor-pointer rounded-[8px] border-0 bg-[#E2E2E2] py-4 text-center font-['Pretendard'] text-[14px] font-bold leading-[1.4] text-gray03";
  const hasAdPrimaryButton = popup.kind === 'success' || popup.kind === 'ad-rest' || popup.kind === 'npay' || popup.kind === 'near-point';
  const primaryAdLabel = AD_PRIMARY_LABEL_BY_KIND[popup.kind] ?? '';
  const primaryAdButtonLabel = isPrimaryAdLoading && hasAdPrimaryButton ? '로딩 중...' : primaryAdLabel;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-[rgba(0,0,0,0.55)] px-5">
      <div className="relative w-[320px]">
        <div
          className="absolute left-0 w-[320px] rounded-2xl bg-gradient-to-t from-white from-[34.503%] to-[#DFD7FF] to-[91.708%] shadow-[0px_5px_16px_0px_rgba(0,0,0,0.1)]"
          style={{ top: '26px', height: `${cardHeight}px` }}
        />
        <button
          type="button"
          aria-label="팝업 닫기"
          onClick={onSkip}
          disabled={isPrimaryAdLoading}
          className="absolute right-5 top-[calc(26px+20px)] z-10 flex h-6 w-6 cursor-pointer items-center justify-center border-0 bg-transparent p-0 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <img src={HighRewardCloseXIcon} alt="" aria-hidden="true" className="h-4 w-4 object-contain" />
        </button>

        <div className="relative flex w-full flex-col items-center gap-[30px] px-[10px] pb-4 pt-0">
          {popup.kind === 'success' ? (
            <>
              <div className="flex w-[300px] flex-col items-center gap-5">
                <img src={HighRewardCrownIcon80} alt="" className="h-20 w-20 object-cover" />
                <h3 className={titleClass}>3.23 타임냥 성공 !</h3>
                <p className="m-0 whitespace-pre-line text-center font-['Pretendard'] text-sm font-bold leading-[1.4] text-gray03">
                  오늘 최대 도전 {popup.successCount}/3회
                </p>
              </div>

              <div className="flex w-[300px] flex-col items-center gap-[10px]">
                <button
                  type="button"
                  onClick={onConfirm}
                  disabled={isPrimaryAdLoading}
                  className={`${primaryBtnClass} disabled:cursor-not-allowed disabled:opacity-55`}
                >
                  {!isPrimaryAdLoading ? (
                    <img src={HighRewardAdIcon} alt="" aria-hidden="true" className="h-4 w-4 object-contain" />
                  ) : null}
                  <span>{primaryAdButtonLabel}</span>
                </button>
                <button type="button" onClick={onSkip} disabled={isPrimaryAdLoading} className={secondaryBtnClass}>
                  포기하기
                </button>
              </div>
            </>
          ) : popup.kind === 'ad-rest' ? (
            <>
              <div className="flex w-[300px] flex-col items-center gap-5">
                <div className="flex h-20 w-20 items-center justify-center text-[48px]">📺</div>
                <h3 className={titleClass}>광고 휴식</h3>
                <p className={descClass}>잠시 광고 보며 쉬고 1P 받아가요</p>
              </div>

              <div className="flex w-[300px] flex-col items-center gap-[10px]">
                <button
                  type="button"
                  onClick={onConfirm}
                  disabled={isPrimaryAdLoading}
                  className={`${primaryBtnClass} disabled:cursor-not-allowed disabled:opacity-55`}
                >
                  {!isPrimaryAdLoading ? (
                    <img src={HighRewardAdIcon} alt="" aria-hidden="true" className="h-4 w-4 object-contain" />
                  ) : null}
                  <span>{primaryAdButtonLabel}</span>
                </button>
                <button type="button" onClick={onSkip} disabled={isPrimaryAdLoading} className={secondaryBtnClass}>
                  무시하고 플레이
                </button>
              </div>
            </>
          ) : popup.kind === 'npay-complete' ? (
            <>
              <div className="flex w-[300px] flex-col items-center gap-5">
                <img src={PartyPopperIcon} alt="" className="h-20 w-20 object-contain" />
                <h3 className={titleClass}>획득완료 !</h3>
                <div className="flex h-[109px] w-[170px] rounded-[10px] bg-[#00DE5A] px-[14px] py-[12px] shadow-[0_8px_30px_rgba(0,0,0,0.12)]">
                  <div className="flex h-full w-full flex-col justify-between">
                    <div className="flex flex-1 items-center justify-center overflow-hidden">
                      <img src={NPAY_ICON_IMAGE} alt="N Pay" className="h-[100px] w-[100px] object-contain" />
                    </div>
                    <div className="flex items-center justify-between">
                      <p className="m-0 whitespace-pre-line font-['Pretendard'] text-[10px] font-medium leading-[1.25] tracking-[-0.4px] text-black">
                        네이버페이{'\n'}포인트 쿠폰
                      </p>
                      <p className="m-0 font-['Pretendard'] text-[16px] font-extrabold leading-none tracking-[-1.2px] text-black">
                        2,000원
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex w-[300px] flex-col items-center gap-[10px]">
                <button type="button" onClick={onConfirm} className={primaryBtnClass}>
                  쿠폰함가기
                </button>
                <button type="button" onClick={onSkip} className={secondaryBtnClass}>
                  닫기
                </button>
              </div>
            </>
          ) : popup.kind === 'npay' ? (
            <>
              <div className="flex w-[300px] flex-col items-center gap-5">
                <img src={HighRewardCrownIcon80} alt="" className="h-20 w-20 object-cover" />
                <h3 className={titleClass}>축하합니다!</h3>
                <div
                  className="w-full"
                  style={{
                    position: 'relative',
                    background: '#03C75A',
                    borderRadius: '8px',
                    padding: '2px',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    className="pointer-events-none absolute inset-0"
                    style={{
                      background: 'linear-gradient(90deg, transparent 20%, rgba(255,255,255,0.9) 50%, transparent 80%)',
                      animation: 'npay-border-shimmer 2s linear infinite',
                    }}
                  />
                  <div className="relative flex h-[54px] w-full items-center justify-center gap-1 rounded-[6px] bg-white">
                    <img src={NPAY_ICON_IMAGE} alt="N Pay" className="h-5 w-5 object-contain" />
                    <span className="font-['Pretendard'] text-[20px] font-extrabold tracking-[-0.5px] text-[#03C75A]">
                      N Pay 2천원권
                    </span>
                  </div>
                </div>
                <p className={descClass}>
                  목표 타임스코어 달성 !{'\n'}
                  리워드를 수령해주세요
                </p>
              </div>

              <div className="flex w-[300px] flex-col items-center gap-[10px]">
                <button
                  type="button"
                  onClick={onConfirm}
                  disabled={isPrimaryAdLoading}
                  className={`${primaryBtnClass} disabled:cursor-not-allowed disabled:opacity-55`}
                >
                  {!isPrimaryAdLoading ? (
                    <img src={HighRewardAdIcon} alt="" aria-hidden="true" className="h-4 w-4 object-contain" />
                  ) : null}
                  <span>{primaryAdButtonLabel}</span>
                </button>
                <button type="button" onClick={onSkip} disabled={isPrimaryAdLoading} className={secondaryBtnClass}>
                  나중에
                </button>
              </div>
            </>
          ) : popup.kind === 'near-point' ? (
            <>
              <div className="flex w-[300px] flex-col items-center gap-5">
                <div className="flex h-20 w-20 items-center justify-center text-[44px]">😿</div>
                <h3 className={titleClass}>0.01초 차이!</h3>
                <p className={descClass}>빈손으로 갈거냥?{'\n'}영상 보고 10P 챙겨가라냥</p>
                {popup.turn === 3 ? (
                  <p className="m-0 text-center font-['Pretendard'] text-[13px] font-bold leading-[1.3] tracking-[-0.4px] text-[#F6475F]">
                    10P 보상 하루 최대 (3/3)
                  </p>
                ) : null}
              </div>
              <div className="flex w-[300px] flex-col items-center gap-[10px]">
                <button
                  type="button"
                  onClick={onConfirm}
                  disabled={isPrimaryAdLoading}
                  className={`${primaryBtnClass} disabled:cursor-not-allowed disabled:opacity-55`}
                >
                  {!isPrimaryAdLoading ? (
                    <img src={HighRewardAdIcon} alt="" aria-hidden="true" className="h-4 w-4 object-contain" />
                  ) : null}
                  <span>{primaryAdButtonLabel}</span>
                </button>
                <button type="button" onClick={onSkip} disabled={isPrimaryAdLoading} className={secondaryBtnClass}>
                  괜찮아요
                </button>
              </div>
            </>
          ) : popup.kind === 'near-free' ? (
            <>
              <div className="flex w-[300px] flex-col items-center gap-5">
                <div className="flex h-20 w-20 items-center justify-center text-[44px]">🥲</div>
                <h3 className={titleClass}>이 아까운 걸 4번이나...?</h3>
                <p className={descClass}>무료탐냥 1회 드릴게요</p>
              </div>
              <div className="flex w-[300px] flex-col items-center gap-[10px]">
                <button type="button" onClick={onConfirm} className={primaryBtnClass}>
                  무료탐냥 받기
                </button>
                <button type="button" onClick={onSkip} className={secondaryBtnClass}>
                  괜찮아요
                </button>
              </div>
            </>
          ) : popup.kind === 'near-exhausted' ? (
            <>
              <div className="flex w-[300px] flex-col items-center gap-5">
                <div className="flex h-20 w-20 items-center justify-center text-[44px]">😥</div>
                <h3 className={titleClass}>위로 보상 소진</h3>
                <p className={descClass}>내일 다시 리셋되요</p>
              </div>
              <div className="flex w-[300px] flex-col items-center gap-[10px]">
                <button type="button" onClick={onClose} className={primaryBtnClass}>
                  확인
                </button>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
